import type {VoidFunctionComponent} from 'react';

import {Spinner} from '../../../../atoms/spinner';

import styles from './styles.module.css';

export const LoadingState: VoidFunctionComponent = () => (
    <div className={styles.wrapper}>
        <Spinner />
    </div>
);
